import { SVGInterface } from "./svg-interface";

function DownloadSvg({ size = 26, strokeColor = "#323232" }: SVGInterface) {
  return(
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 10V13.5C1 13.5 1 14 1.42424 14.5C1.84848 15 2.27273 15 2.27273 15C2.27273 15 11.6061 15 13.303 15C15 15 15 13.5 15 13.5V10" stroke={strokeColor} stroke-width="1.2" stroke-linecap="round"/>
      <path d="M7.5 1V11M7.5 11L11 8.5M7.5 11L4 8.5" stroke={strokeColor} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
}

export default DownloadSvg